import { Component, Input, OnInit } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { IFlightSearchResponse } from 'src/app/models/response/flight.response';
import { LoaderService } from 'src/app/services';

@Component({
  selector: 'app-flight-multi-itinerary',
  templateUrl: './flight-multi-itinerary.component.html',
  styleUrls: ['./flight-multi-itinerary.component.scss']
})
export class FlightMultiItineraryComponent implements OnInit {

  @Input() multiCityFlightData: IFlightSearchResponse[] = []

  constructor( public loaderService: LoaderService
  ) { }
  scrolled: boolean = false;
  selectedItem: any = "";
  singleTrip: any = "";
  singleTripTotal;
  selectedFistTrip;

  ngOnInit(): void {
  }

  select(newValue) {
    this.selectedItem = newValue;
    localStorage.setItem('flight_Item', JSON.stringify(this.selectedItem));
    this.singleTrip = JSON.parse(localStorage.getItem('flight_Item')!);
    this.singleTripTotal = this.singleTrip.flightfare.totalnet
  }

  selectFistTrip(item) {
    this.selectedFistTrip = (item)
  }

  itinerary: OwlOptions = {
    loop: true,
    margin: 20,
    autoplay: false,
    autoplayHoverPause: true,
    autoplaySpeed: 950,
    navSpeed: 700,
    dots: true,
    nav: true,
    navText: ['<', '>'],
    responsive: {
      0: {
        items: 1
      },
      425: {
        items: 1
      },
      740: {
        items: 2
      },
      940: {
        items: 2
      }
    }
  }
}
